import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export function ConfirmationPrivateInfoDialog({
  open,
  handleClose,
  handleConfirm,
}: {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}) {
  return (
    <Dialog open={open} onClose={handleClose} scroll="paper">
      <DialogTitle>Informace pro badatele</DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText>
          <p>
            Informace poskytované subjektu údajů podle čl. 13 nařízení
            Evropského parlamentu a Rady EU 2016/679 ze dne 27. dubna 2016 o
            ochraně fyzických osob v souvislosti se zpracováním osobních údajů a
            o volném pohybu těchto údajů a o zrušení směrnice 95/46/ES (obecné
            nařízení o ochraně osobních údajů, dále jen „GDPR“):
          </p>
          <br />

          <p>
            <b>Správcem</b> osobních údajů podle GDPR je Univerzita Karlova,
            Ústav dějin a archiv Univerzity Karlovy, IČO: 00216208, Poštovní
            adresa: Ovocný trh 560/5, 116 36 Praha 1, e-mailová adresa:
            udauk@ruk.cuni.cz ID datové schránky: piyj9b4.
          </p>
          <br />

          <p>
            <b>Kontaktní údaje pověřence pro ochranu osobních údajů</b> – Mgr.
            Jan Jindra, e-mail: gdpr@cuni.cz,telefon: +420 224 491 740.
          </p>
          <br />

          <p>
            <b>Právní základ</b> pro zpracování: čl. 6 odst. 1 písm. c) GDPR –
            zpracování nezbytné pro plnění právní povinnosti: zákon č. 499/2004
            Sb. § 34 odst. 1, 3, 4, 5, 6, § 35, § 37 odst. 2 až 13, § 38 odst.
            1) písm. c), d), e), odst. 2, odst. 5, § 38a; vyhláška č. 645/2004
            Sb. příloha č. 3.
          </p>
          <br />

          <p>
            <b>Doba, po kterou budou osobní údaje uloženy:</b> Platí skartační
            lhůty uvedené ve spisovém a skartačním plánu Univerzity Karlovy,
            který je součástí Spisového řádu Univerzity Karlovy vydaného jako
            pokyn rektora UK č. 6/2013.
          </p>
          <br />

          <p>
            <b>Práva subjektu údajů:</b> Subjekt údajů má podle čl. 15 GDPR
            právo na přístup k osobním údajům, které se ho týkají, podle čl. 16
            GDPR právo požadovat po správci opravu nepřesných osobních údajů,
            které se ho týkají, podle čl. 17 GDPR právo na výmaz osobních údajů,
            které se ho týkají. Právo na výmaz nelze uplatnit, pokud jde o
            zpracování pro účely archivace ve veřejném zájmu, výmaz osobních
            údajů se dle čl. 17 odst. 3 písm. d) GDPR proto v archivních
            souborech uložených v Archivu Univerzity Karlovy neprovádí. Subjekt
            údajů má právo na to, aby správce omezil zpracování osobních údajů
            subjektu údajů v případech vyjmenovaných v čl. 18 GDPR. Subjekt
            údajů má právo požadovat, aby ho správce informoval o příjemcích
            osobních údajů podle čl. 19 GDPR. Správce neprovádí zpracování
            osobních údajů automatizovaně, právo na přenositelnost údajů podle
            čl. 20 GDPR se proto neuplatní.{' '}
            <b>
              Podle čl. 21 GDPR má subjekt údajů právo kdykoli vznést námitku
              proti zpracování osobních údajů, které se jej týkají, jde-li o
              zpracování nezbytné pro splnění úkolu prováděného ve veřejném
              zájmu nebo při výkonu veřejné moci podle čl. 6 odst. 1 písm. e)
              GDPR.
            </b>{' '}
            Pokud je zpracování osobních údajů subjektu údajů založeno na
            souhlasu subjektu údajů se zpracováním jeho osobních údajů, má
            subjekt údajů právo souhlas kdykoliv odvolat. Odvoláním není dotčena
            zákonnost zpracování založená na souhlasu uděleném před jeho
            odvoláním.{' '}
            <b>Subjekt údajů má právo podat stížnost u dozorového úřadu</b>,
            kterým je Úřad pro ochranu osobních údajů. Poštovní adresa: ÚOOÚ,
            Pplk. Sochora 27, 170 00 Praha 7, E-mailová adresa: posta@uoou.cz,
            ID datové schránky: qkbaa2n.
          </p>
          <br />

          <p>
            Při zpracování osobních údajů správcem nedochází k automatizovanému
            rozhodování ani k profilování.
          </p>
          <br />

          <p>
            <b>Příjemci</b>, příp. kategorie příjemců: osobní údaje badatele dle
            § 37 odst. 3 a § 35 a), b), c) zákona č. 499/2004 Sb. (v rozsahu
            jméno, příjmení, datum a místo narození, státní občanství, adresa
            místa pobytu na území ČR, případně bydliště v cizině, adresy, na
            kterou mají být doručovány písemnosti podle zvláštního právního
            předpisu), se poskytují v souvislosti se získáním souhlasu k
            nahlížení do archiválií, které obsahují osobní údaje žijících osob,
            subjektu údajů, do jehož osobních údajů má být nahlíženo (dle ust. §
            37 odst. 2 a 3 zákona č. 499/2004 Sb.); organizační složky státu,
            ozbrojené síly, bezpečnostní sbory, zpravodajské služby ČR, územní
            samosprávné celky, jakož i osoby, které jsou podle zvláštních
            právních předpisů oprávněny nahlížet do dokumentů, jsou oprávněny
            nahlížet v archivech do archiválií, jejichž původcem je stát nebo
            územní samosprávný celek dle ustanovení § 38 odst. 5 zákona č.
            499/2004 Sb.
          </p>
          <br />

          <p>
            Správce nepředává ani nemá v úmyslu předat osobní údaje do třetí
            země nebo mezinárodní organizaci.
          </p>
          <br />

          <p>
            Poskytnutí osobních údajů badatelem je zákonným požadavkem; v
            případě neposkytnutí těchto údajů nebude badateli umožněno nahlížení
            do archiválií. Tato Příloha č. 1 je nedílnou součástí badatelského
            listu.
          </p>
          <br />

          <p>
            <b>Prohlášení badatele:</b>
            <br /> Stvrzuji, že jsem se seznámil s obsahem informace a beru ji
            na vědomí.
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary">
          Souhlasím
        </Button>
      </DialogActions>
    </Dialog>
  );
}
